import { baseApi } from ".";

export interface CityResponse {
  id: number;
  name_ru: string;
  name_kk: string;
  name_en?: string;
  region_ru: string;
  region_kk: string;
  region_en?: string;
  parent_region?: number;
  city_type?: "region" | "national_city" | "city";
}

export interface RegionResponse {
  id: number;
  name_ru: string;
  name_kk: string;
  name_en: string;
  city_type: "region" | "national_city";
}

export interface CityByRegionResponse {
  id: number;
  name_ru: string;
  name_kk: string;
  name_en: string;
  region_ru: string;
  region_kk: string;
  region_en: string;
  parent_region: number;
  city_type: "city";
}

export interface UniversityResponse {
  id: number;
  name: string;
}

export const commonApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCities: builder.query<CityResponse[], void>({
      query: () => ({
        url: "/api/cities/",
        method: "GET",
        credentials: "include",
      }),
    }),

    getRegions: builder.query<RegionResponse[], void>({
      query: () => ({
        url: "/api/regions/",
        method: "GET",
        credentials: "include",
      }),
    }),

    getCitiesByRegion: builder.query<CityByRegionResponse[], number>({
      query: (regionId) => ({
        url: `/api/cities/by-region/?region_id=${regionId}`,
        method: "GET",
        credentials: "include",
      }),
    }),
    getUniversities: builder.query<UniversityResponse[], void>({
      query: () => ({
        url: "/api/universities/",
        method: "GET",
        credentials: "include",
      }),
    }),
  }),
});

export const { useGetCitiesQuery, useGetRegionsQuery, useGetCitiesByRegionQuery, useGetUniversitiesQuery } = commonApi;
